module.exports = __webpack_public_path__ + "static/product-1-a108f8aa510e9f32f5f8b7a439357e04.png";